<form (ngSubmit)="onCreateOrganization()" [formGroup]="form" awairForm>
  <ng-container formHeader>
    <!-- Form Headers -->
    <h2 awairFormTitle>Create an Organization</h2>
    <h3 awairFormSubTitle>Create an Organization to manage your devices.</h3>
    <!-- /.Form Headers -->
  </ng-container>

  <ng-container formBody>
    <!-- Name Input -->
    <label awairInputLabel>Name</label>
    <input type="text"
           autocomplete="off"
           formControlName="organizationName"
           placeholder="Name your Organization"
           awairInput>
    <!-- /.Name Input -->

    <!-- Error message -->
    <awair-input-error style="margin-bottom: 51px;"
                       [message]="errorMessage">
    </awair-input-error>
    <!-- /.Error message -->
  </ng-container>

  <ng-container formFooter>
    <div class="__button-group">
      <button type="button"
              class="__cancel-button"
              [disabled]="isOrganizationCreating || isOrganizationCreated"
              (click)="onCancel()">
        <span class="__button-wrapper">Cancel</span>
      </button>
      <button type="submit"
              class="__submit-button"
              [disabled]="!form.valid || isOrganizationCreating || isOrganizationCreated">
        <span class="__button-wrapper">Request</span>
      </button>
    </div>
  </ng-container>
</form>
